import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type { SpeechOptions } from "../../managers/ia/types/const";

export type AiWriting = {
    generateAnswerWithAI: (
        currentAnswer: string,
        body: string,
        speechOption: SpeechOptions,
        currentAnswerToReplace: string,
    ) => Promise<string | null>;
};

export function useAiWriting(): AiWriting {
    const { iaManager } = useSdk();

    return useMemo<AiWriting>(
        () => ({
            generateAnswerWithAI: (...args) =>
                iaManager.generateAnswerWithAI(...args),
        }),
        [iaManager],
    );
}
